export default __webpack_public_path__ + "static/media/meliImg_1.d3875e47.webp";